import { DEFAULT_FIRST_FORM_VALUE, useFilterStore } from "../stores/FilterStore";

const SHOW_ALL_VALUES = ["any", "", DEFAULT_FIRST_FORM_VALUE];

interface Property {
  price: number;
}
interface PropertyWithBedrooms extends Property {
  beds: number;
  bedrooms?: never;
}
interface PropertyWithBeds extends Property {
  bedrooms: number;
  beds?: never;
}
type PropertyWithBedsType = PropertyWithBedrooms | PropertyWithBeds;

const checkBeds = (property: PropertyWithBedsType, bedrooms: string) => {
  if (SHOW_ALL_VALUES.includes(bedrooms)) return true;
  if (property.bedrooms !== undefined) {
    return property.bedrooms >= Number(bedrooms);
  }
  if (property.beds !== undefined) {
    // @ts-ignore
    return property.beds >= Number(bedrooms);
  }
  return false;
};

export const useFilterData = () => {
  const { bedrooms, minPrice, maxPrice } = useFilterStore(["bedrooms", "minPrice", "maxPrice"]);

  const filterData = <T extends PropertyWithBedsType>(data: T[]): T[] => {
    return data.filter((property) => {
      const isBedsOkay = checkBeds(property, bedrooms);
      const isHigherThanMinPrice =
        SHOW_ALL_VALUES.includes(minPrice) || property.price >= Number(minPrice);
      const isLowerThanMaxPrice =
        SHOW_ALL_VALUES.includes(maxPrice) || property.price <= Number(maxPrice);
      return isBedsOkay && isHigherThanMinPrice && isLowerThanMaxPrice;
    });
  };

  return { filterData };
};
